// extracted by mini-css-extract-plugin
export default {"AIGBanner":"AlertBanner_AIGBanner__+JOiv","closeBanner":"AlertBanner_closeBanner__JdUBW"};